<template >
<div>

    <b-container >
    <div>
      <section id="capture">
        <b-row class="card-row">
          <b-col class="card-col">
            <img :src="setCard(0, 0)" style="width: 100%;" alt="" @click="onCardClicked([0, 0])">
            <div class="check-mark" v-if="board[0][0].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(0, 1)" style="width: 100%;" alt="" @click="onCardClicked([0, 1])">
            <div class="check-mark" v-if="board[0][1].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(0, 2)" style="width: 100%;" alt="" @click="onCardClicked([0, 2])">
            <div class="check-mark" v-if="board[0][2].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(0, 3)" style="width: 100%;" alt="" @click="onCardClicked([0, 3])">
            <div class="check-mark" v-if="board[0][3].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
        </b-row>
        <b-row class="card-row">
          <b-col class="card-col">
            <img :src="setCard(1, 0)" style="width: 100%;" alt="" @click="onCardClicked([1, 0])">
            <div class="check-mark" v-if="board[1][0].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(1, 1)" style="width: 100%;" alt="" @click="onCardClicked([1, 1])">
            <div class="check-mark" v-if="board[1][1].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(1, 2)" style="width: 100%;" alt="" @click="onCardClicked([1, 2])">
            <div class="check-mark" v-if="board[1][2].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(1, 3)" style="width: 100%;" alt="" @click="onCardClicked([1, 3])">
            <div class="check-mark" v-if="board[1][3].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
        </b-row>
        <b-row class="card-row">
          <b-col class="card-col">
            <img :src="setCard(2, 0)" style="width: 100%;" alt="" @click="onCardClicked([2, 0])">
            <div class="check-mark" v-if="board[2][0].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(2, 1)" style="width: 100%;" alt="" @click="onCardClicked([2, 1])">
            <div class="check-mark" v-if="board[2][1].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(2, 2)" style="width: 100%;" alt="" @click="onCardClicked([2, 2])">
            <div class="check-mark" v-if="board[2][2].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(2, 3)" style="width: 100%;" alt="" @click="onCardClicked([2, 3])">
            <div class="check-mark" v-if="board[2][3].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
        </b-row>
        <b-row class="card-row">
          <b-col class="card-col">
            <img :src="setCard(3, 0)" style="width: 100%;" alt="" @click="onCardClicked([3, 0])">
            <div class="check-mark" v-if="board[3][0].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(3, 1)" style="width: 100%;" alt="" @click="onCardClicked([3, 1])">
            <div class="check-mark" v-if="board[3][1].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(3, 2)" style="width: 100%;" alt="" @click="onCardClicked([3, 2])">
            <div class="check-mark" v-if="board[3][2].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(3, 3)" style="width: 100%;" alt="" @click="onCardClicked([3, 3])">
            <div class="check-mark" v-if="board[3][3].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
        </b-row>
      </section>
    </div>
    
    <b-modal id="you-won-modal" size="xl" hide-header-close hide-footer @hidden="resetBoard">
      <template slot="modal-title" class="modal-header-spurs">
        <div class="boardTopLine">
          <!--<img src="../assets/images/share_spurs.png" class="img-fluid spursShareTopPop" alt="Spurs 16">-->
          <img src="../assets/images/LOTERIA_WINNERHEADER.png" class="img-fluid spursShareTopPop" alt="Spurs 16">
        </div>
      </template>

      <div class="text-center">
      <section id="screenshot" style="padding: 20px; pointer-events: none" class="capture-2">
                <b-row class="card-row">
          <b-col class="card-col">
            <img :src="setCard(0, 0)" style="width: 100%;" alt="" @click="onCardClicked([0, 0])">
            <div class="check-mark" v-if="board[0][0].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(0, 1)" style="width: 100%;" alt="" @click="onCardClicked([0, 1])">
            <div class="check-mark" v-if="board[0][1].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(0, 2)" style="width: 100%;" alt="" @click="onCardClicked([0, 2])">
            <div class="check-mark" v-if="board[0][2].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(0, 3)" style="width: 100%;" alt="" @click="onCardClicked([0, 3])">
            <div class="check-mark" v-if="board[0][3].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
        </b-row>
        <b-row class="card-row">
          <b-col class="card-col">
            <img :src="setCard(1, 0)" style="width: 100%;" alt="" @click="onCardClicked([1, 0])">
            <div class="check-mark" v-if="board[1][0].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(1, 1)" style="width: 100%;" alt="" @click="onCardClicked([1, 1])">
            <div class="check-mark" v-if="board[1][1].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(1, 2)" style="width: 100%;" alt="" @click="onCardClicked([1, 2])">
            <div class="check-mark" v-if="board[1][2].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(1, 3)" style="width: 100%;" alt="" @click="onCardClicked([1, 3])">
            <div class="check-mark" v-if="board[1][3].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
        </b-row>
        <b-row class="card-row">
          <b-col class="card-col">
            <img :src="setCard(2, 0)" style="width: 100%;" alt="" @click="onCardClicked([2, 0])">
            <div class="check-mark" v-if="board[2][0].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(2, 1)" style="width: 100%;" alt="" @click="onCardClicked([2, 1])">
            <div class="check-mark" v-if="board[2][1].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(2, 2)" style="width: 100%;" alt="" @click="onCardClicked([2, 2])">
            <div class="check-mark" v-if="board[2][2].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(2, 3)" style="width: 100%;" alt="" @click="onCardClicked([2, 3])">
            <div class="check-mark" v-if="board[2][3].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
        </b-row>
        <b-row class="card-row">
          <b-col class="card-col">
            <img :src="setCard(3, 0)" style="width: 100%;" alt="" @click="onCardClicked([3, 0])">
            <div class="check-mark" v-if="board[3][0].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(3, 1)" style="width: 100%;" alt="" @click="onCardClicked([3, 1])">
            <div class="check-mark" v-if="board[3][1].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(3, 2)" style="width: 100%;" alt="" @click="onCardClicked([3, 2])">
            <div class="check-mark" v-if="board[3][2].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
          <b-col class="card-col">
            <img :src="setCard(3, 3)" style="width: 100%;" alt="" @click="onCardClicked([3, 3])">
            <div class="check-mark" v-if="board[3][3].isClicked"><img src="../assets/cards/bean.png" class="bean"/></div>
          </b-col>
        </b-row>
      </section>
      <div style="display:flex;justify-content:center;">
          <!--<div  class="inline_gameScreenNav inline_gameScreenNavBTN menu-selectDark" style="margin-left: 12px;" @click="saveImage" href="#">Save</div>-->
          <div v-if="language === 'english'" class="inline_gameScreenNav inline_gameScreenNavBTN menu-selectDark" style="margin-left: 12px;" @click="closeModal"  href="#">Replay</div>
          <div v-else-if="language === 'spanish'" class="inline_gameScreenNav inline_gameScreenNavBTN menu-selectDark" style="margin-left: 12px;" @click="closeModal"  href="#">Jugar De Nuevo</div>
        </div>
      </div>


      <template slot="modal-footer" class="modal-header-spurs"> 

      </template>
    </b-modal>


  </b-container>
</div>

</template>

<script>
import NavBar from './NavBar'
import html2canvas from 'html2canvas'
import request from 'superagent'

export default {
  name: "GameScreen",
  props: ['newDeck', 'useNewDeck', 'language'],
  components: {NavBar},
  created() {
    
    // When the component is created generate randomized cards
    // and randomize them, unless useNewDeck is true then
    // use the provided newDeck array
    if(this.useNewDeck){
      this.board = this.newDeck
        .map((val, index) => {
        return val.map(cell =>({
          value: cell,
          isClicked: false
        }))
      });
    }
    else{
      var initial_array = this.shuffleArray(this.card_array);
      this.randomized_cards = initial_array.slice(0, 16)
      this.board = this.listToMatrix(this.randomized_cards, 4)
        .map((val, index) => {
        return val.map(cell =>({
          value: cell,
          isClicked: false
        }))
      });
    }
  },
  destroyed(){
    this.resetBoard();
  },
  data(){
    return{
      output: null,
      selectedVals: [],
      rowCounts: {},
      colCounts: {},
      card_array: [
        0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,
        21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,
        38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53
      ],
      amountOfCards: 16,
      randomized_cards: [],
      board: null,
      showTweetButton: true
    }
  },
  methods: {
    saveImage(){
      html2canvas(document.querySelector("#screenshot")).then(canvas => {
        var screenshot_data = canvas.toDataURL()
        var url = screenshot_data.replace(/^data:image\/[^;]+/, 'data:application/octet-stream');
        var link = document.createElement("a");
        link.download = 'myboard.png';
        link.href = url;
        link.setAttribute("type", "hidden"); // make it hidden if needed
        document.body.appendChild(link);
        link.click();
      });
    },
    tweet(){
      html2canvas(document.querySelector("#screenshot"), {scale: 5}).then(canvas => {
        this.showTweetButton = false;
        request
          .post('https://spursloteria.com/api/post-picture')
          .send({ token: '3j4a76BKb5Rzx7s6V2W2WuYG6SW6B24dXy2447CG', media: canvas.toDataURL() })
          .then(res => {
            if(res.status === 200){
              var tweet = "I just completed my #SpursLoteria board. Build yours now for a chance to win tickets: "
              var encodedTweet = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(tweet) + '%20' + encodeURIComponent(res.body.tweet_data.text) + '%20' + encodeURIComponent('https://spurs.com/spurs-loteria');
              if(helpers.isMobile()){
                setTimeout(function () { window.location = encodedTweet }, 25);
                window.location = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(tweet) + '%20' + encodeURIComponent(res.body.tweet_data.text) + '%20' + encodeURIComponent('https://spurs.com/spurs-loteria');
              }else{
                window.location = encodedTweet;
              }
            }
        });
      });
    },
    closeModal(){
      this.resetBoard();
      this.$bvModal.hide('you-won-modal');
    },
    screenshot(){
      this.$bvModal.show('screenshot-modal');
      html2canvas(document.querySelector("#capture")).then(canvas => {
        this.output = canvas.toDataURL()
      });
    },
    toTutorial(){
      this.$parent.showTutView = true;
      this.$parent.showGameScreen = false;
    },
    // Navigate to the main menu
    toMainMenu(){
      this.$parent.showGameMenu = true;
      this.$parent.showGameScreen = false;
      this.$parent.showBoardBuilder = false;
    },
    // Set the image for the card of pos
    setCard(first_pos, second_pos){
      return require(`../assets/cards/${this.board[first_pos][second_pos].value}.jpg`)
    },

    // When the user clicks away from the modal reset the board
    closeModal(){
      this.resetBoard();
      this.$bvModal.hide('you-won-modal');
    },
    
    // Shuffle the given array
    shuffleArray(array) {
      var currentIndex = array.length, temporaryValue, randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    },

    // Re-randomized the cards and remove the beans 
    resetBoard(){
      this.board = null;
      this.selectedVals = [];
      this.colCounts = {};
      this.rowCounts = {};
      var shuffled_array = this.shuffleArray(this.card_array);
      var randomized_cards = shuffled_array.slice(0, 16)
      this.board = this.listToMatrix(randomized_cards, 4)
        .map((val, index) => {
        return val.map(cell =>({
          value: cell,
          isClicked: false
        }))
      });

    },

    // Convert a 16 element array to a 4x4 2D array
    listToMatrix(list, elementsPerSubArray) {
      var matrix = [], i, k;

      for (i = 0, k = -1; i < list.length; i++) {
        if (i % elementsPerSubArray === 0) {
          k++;
          matrix[k] = [];
        }

        matrix[k].push(list[i]);
      }

      return matrix;
    },
    
    // Add the pos of the card clicked to the selectedVals 2D array
    onCardClicked(coord) {
      if(!this.isItemInArray(this.selectedVals, coord)){
        this.board[coord[0]][coord[1]].isClicked = true;
        this.selectedVals.push(coord);
        this.updateCounts(coord);
        if(this.isDiagonal()){
          this.$bvModal.show('you-won-modal');
        }
        else if(this.isHorizontal()){
          this.$bvModal.show('you-won-modal');
        }
        else if(this.isVertical()){
          this.$bvModal.show('you-won-modal');
        }
      }else{
        this.updateCounts(coord, true)
        this.board[coord[0]][coord[1]].isClicked = false;
        this.selectedVals.forEach((arrays, index) =>{
          if(arrays[0] === coord[0] && arrays[1] === coord[1]){
            return this.selectedVals.splice(index, 1)
          }
        })
      }
    },

    // Check if an item is in a 2D array
    isItemInArray(array, item) {
      for (var i = 0; i < array.length; i++) {
          // This if statement depends on the format of your array
        if (array[i][0] == item[0] && array[i][1] == item[1]) {
              console.log(array[i][0], array[i][1])
              return true;   // Found it
        }
      }
      return false;   // Not found
    },
    cardDisabled(coord) {
      return this.selectedVals.some(vals => vals[0] === coord[0] && vals[1] === coord[1]);
    },
    updateCounts(coord, remove=false) {
      const rowIndex = coord[0];
      const colIndex = coord[1];
      if(remove){
        this.rowCounts[rowIndex] = this.rowCounts[rowIndex] ? this.rowCounts[rowIndex] - 1 : 1;
        this.colCounts[colIndex] = this.colCounts[colIndex] ? this.colCounts[colIndex] - 1 : 1;
      }else{
        this.rowCounts[rowIndex] = this.rowCounts[rowIndex] ? this.rowCounts[rowIndex] + 1 : 1;
        this.colCounts[colIndex] = this.colCounts[colIndex] ? this.colCounts[colIndex] + 1 : 1;
      }
    },
    isDiagonal() {
      if (this.selectedVals.length < 4) return false;
      // top left to bottom right
      // [0, 0] [1, 1], [2, 2], [3, 3], etc..
      const isTLtoBR = this.selectedVals.filter(val => val[0] === val[1]);
      if (isTLtoBR.length >= 4) return true;

      // top right to bottom left
      // [0, 3], [1, 2], [2, 1], [3, 0], etc..
      const rowLen = this.board[0].length;
      const isTRtoBL = this.selectedVals.filter(val => {
        return (rowLen -1) - val[0] === val[1];
      });      
      if (isTRtoBL.length >= 4) return true;

      return false;
    },
    isHorizontal() {
      if (this.selectedVals.length < 4) return false;
      if(Object.values(this.rowCounts).some(row => row >= 4)) return true;
    },
    isVertical() {
      if (this.selectedVals.length < 4) return false;
      if(Object.values(this.colCounts).some(col => col >= 4)) return true;
    }
  },
};
</script>


